module.exports = {
  appId: "96d9e117-55d3-4d57-ae5a-aee73ea310fe",
  tenantId: "https://login.microsoftonline.com/5ceca96d-5895-4b57-8130-1460fc5ec969",
  // Original scopes for EPIIC API
  scopes: ["api://96d9e117-55d3-4d57-ae5a-aee73ea310fe/user.read"],
  // New scopes for Options API
  optionsApiScopes: ["api://ebf32db1-a32a-45d8-9fbe-53ef209556c8/user.read"],
  // Keep these IDs for reference
  epiicApiClientId: "96d9e117-55d3-4d57-ae5a-aee73ea310fe",
  optionsApiClientId: "ebf32db1-a32a-45d8-9fbe-53ef209556c8",
  // Add redirect URI - this will be configured from the App.js file
  // Make sure all variants of this are registered in Azure Portal:
  // - https://epiic.rbaconsulting.com
  // - https://stage-epiic.rbaconsulting.com (adjust to actual staging URL)
  // - https://dev-epiic.rbaconsulting.com (adjust to actual dev URL)
  // - http://localhost:3000 (adjust port if different)
};